export const truncateEthAddress = (walletAddress: string) =>
  walletAddress.slice(0, 6) + '...' + walletAddress.slice(-4);
